import { Link } from "react-router-dom";
import { Calendar, Tag, ArrowRight } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { CtaSection } from "@/components/CtaSection";
import { POSTS } from "@/data/blog";
import { breadcrumbSchema } from "@/lib/schema";

const fmtData = (d) => new Date(d + "T12:00:00").toLocaleDateString("pt-BR", { day: "2-digit", month: "long", year: "numeric" });

export default function BlogPage() {
  const crumbs = [
    { name: "Início", url: "/" },
    { name: "Blog", url: "/blog" },
  ];
  return (
    <main className="max-w-7xl mx-auto px-4 md:px-8" data-testid="blog-page">
      <Seo
        title="Blog da Desentupidora em Guarulhos | Dicas de Prevenção e Desentupimento"
        description="Dicas de prevenção de entupimentos, limpeza de fossa, hidrojateamento e guias de preços para moradores e empresas de Guarulhos."
        path="/blog"
        jsonLd={[breadcrumbSchema(crumbs)]}
      />
      <Breadcrumbs items={crumbs} />
      <h1 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl text-brand-dark uppercase tracking-tight py-4">
        Blog e <span className="text-brand-red">Dicas</span>
      </h1>
      <p className="text-gray-600 text-sm md:text-base max-w-3xl mb-10">
        Conteúdo prático para moradores e empresas de Guarulhos: como evitar entupimentos, quando limpar a fossa, quanto custam os serviços e muito mais.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 pb-10">
        {POSTS.map((p) => (
          <Link key={p.slug} to={`/blog/${p.slug}`} className="group bg-white rounded-xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-xl transition-shadow" data-testid={`blog-card-${p.slug}`}>
            <div className="h-44 overflow-hidden">
              <img src={p.image} alt={p.titulo} loading="lazy" width="480" height="320" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-5">
              <div className="flex items-center gap-3 text-xs text-gray-500 mb-2">
                <span className="flex items-center gap-1"><Tag size={12} className="text-brand-red" /> {p.categoria}</span>
                <span className="flex items-center gap-1"><Calendar size={12} /> {fmtData(p.data)}</span>
              </div>
              <h2 className="font-heading font-bold text-base text-brand-dark group-hover:text-brand-red transition-colors leading-snug">{p.titulo}</h2>
              <p className="text-gray-500 text-sm mt-2 line-clamp-2">{p.descricao}</p>
              <span className="inline-flex items-center gap-1 text-brand-red font-heading font-bold text-sm mt-3">
                Ler artigo <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
              </span>
            </div>
          </Link>
        ))}
      </div>
      <CtaSection titulo="Precisa de um desentupimento agora?" texto="Não espere o problema piorar. Fale com nossa equipe 24 horas pelo WhatsApp e receba orçamento gratuito em minutos." />
    </main>
  );
}
